import React from 'react'
import api from 'wordpress-rest-api-oauth-1'
import Header from './Header'
import PostsList from './PostsList'
import PostBox from './PostBox'
import Welcome from './Welcome'

const API_KEY = 'x1sMWqTX8fqj'
const API_SECRET = 'LPDT08SF30AnBf7S6SsgI3G1j214SlFnlbFLfAv28IqqiqXB'
//const CALLBACK_URL = 'http://localhost:3000/'
const CALLBACK_URL = 'https://lbdemo.silvanhagen.com/'
const BROKER_URL = 'https://apps.wp-api.org/'

export default class App extends React.Component {
	constructor() {
		super()
		this.state = {
			posts: [],
			isLoadingPosts: false,
			user: null,
			url: ''
		}
	}
	componentDidMount() {
		let url = localStorage.getItem('url')
		if (url) {
			this.onConnect(url)
		}
	}
	componentWillUnmount() {
		clearInterval(this.interval)
	}
	loadPosts() {
		this.setState({isLoadingPosts:true})
		let args = {
			_embed: true,
			per_page: 20,
			status: this.state.user ? 'any' : 'publish',
			context: this.state.user ? 'edit' : 'view'
		}
		window.apiHandler.get('/wp/v2/posts', args)
			.then( posts => {
				this.setState({posts, isLoadingPosts:false})
			})
	}
	onConnect(url) {
		this.setState({url})
		localStorage.setItem('url', url)
		window.apiHandler = new api({
			url: url,
			brokerURL: BROKER_URL,
			brokerCredentials: {
				client: {
					public: API_KEY,
					secret: API_SECRET
				}
			},
			callbackURL: CALLBACK_URL
		})
		window.apiHandler.restoreCredentials()

		if (window.apiHandler.hasCredentials()) {
			this.onLoggedIn()
		} else if (window.apiHandler.hasRequestToken()) {
			this.onLogin()
		}
		this.loadPosts()
		this.interval = setInterval(() => this.loadPosts(), 5000)
	}
	onLogin() {
		window.apiHandler.authorize()
			.then(() => this.onLoggedIn())
	}
	onLogout() {
		this.setState({user:null}, () => this.loadPosts())
		window.apiHandler.removeCredentials()
	}
	onLoggedIn() {
		let args = {
			_envelope: true,
			context: 'edit'
		}
		window.apiHandler.get('/wp/v2/users/me', args)
			.then(data => data.body)
			.then(user => this.setState({user}))
			.then(() => this.loadPosts())
	}
	onSwitchSite() {
		this.setState({url:''})
		window.apiHandler.removeCredentials()
		localStorage.removeItem('url')
	}
	onRejectPost(post) {
		window.apiHandler.del(`/wp/v2/posts/${post.id}`)
			.then(() => this.loadPosts())
	}
	onApprovePost(post) {
		window.apiHandler.post(`/wp/v2/posts/${post.id}`, {status: 'publish'})
			.then(() => this.loadPosts())
	}
	onLikePost(post) {
		window.apiHandler.post(`/liveblog-likes/v1/posts/${post.id}/like`)
			.then(response => {
				this.setState({
					posts: this.state.posts.map(p => {
						if (p.id === post.id) {
							p.liveblog_likes = response.count
						}
						return p
					})
				})
			})
	}
	render() {
		if (!this.state.url) {
			return <Welcome
				onConnect={url => this.onConnect(url)}
			/>
		}
		return <div className="app">
				<Header
					user={this.state.user}
					onLogin={() => this.onLogin()}
					onLogout={() => this.onLogout()}
					onSwitchSite={() => this.onSwitchSite()}
				/>
				<div className="posts">
					{this.state.user && this.state.user.capabilities.edit_posts ?
					<PostBox
						user={this.state.user}
						onDidPublish={post => {
							let posts = this.state.posts
							this.loadPosts()
						}}
					/>
					: null}
					<PostsList
						user={this.state.user}
						posts={this.state.posts}
						isLoadingPosts={this.state.isLoadingPosts}
						showFilter={this.state.user}
						onRejectPost={post => this.onRejectPost(post)}
						onApprovePost={post => this.onApprovePost(post)}
						onLikePost={post => this.onLikePost(post)}
					/>
				</div>
		</div>
	}
}



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/